/* @flow */

import React from 'react';

import TwoFactorNudgeViewComponent from './view';

import UserService from 'services/UserService';
import NotificationHelper from 'lib/notifications';

type TwoFactorNudgeComponentProps = {
  onComplete: () => void;
}

type TwoFactorNudgeComponentState = {
  dialogOpen: boolean;
}

export default class TwoFactorNudgeComponent extends React.Component<TwoFactorNudgeComponentProps, TwoFactorNudgeComponentState> {

  constructor(props) {
    super(props);
    this.state = { dialogOpen: false };
  }

  openDialog = () => this.setState({ dialogOpen: true });

  closeDialog = () => this.setState({ dialogOpen: false });

  completeSetup = async () => {
    try {
      await UserService.notifyTwoFactorUpdated();
    } catch (e) {
      console.error(e);
    }

    this.setState({ dialogOpen: false });
    NotificationHelper.createNotification(NotificationHelper.TYPE_SUCCESS, 'notifications.2fa.success');

    // Let the notifications panel re-check the 2FA state and drop this row now that it's activated.
    if (this.props.onComplete) this.props.onComplete();
  }

  render() {
    return (
      <TwoFactorNudgeViewComponent
        dialogOpen={this.state.dialogOpen}
        openDialog={this.openDialog}
        closeDialog={this.closeDialog}
        completeSetup={this.completeSetup}
      />
    );
  }
}
